// @flow
import React from 'react';
import Chip from 'material-ui/Chip';
import { red900, green300 } from 'material-ui/styles/colors';

const styles = {
  chip: {
    margin: 8,
  },
};

type Props = {
  active: ?boolean,
};

/**
 * TODO clean up colours
 */
const ActiveCell = ({ active }: Props) => (
  <div>
    {active ? (
      <Chip style={styles.chip} backgroundColor={green300}>
        Active
      </Chip>
    ) : (
      <Chip style={styles.chip} backgroundColor={red900}>
        Inactive
      </Chip>
    )}
  </div>
);

export default ActiveCell;



// WEBPACK FOOTER //
// ./src/components/shared/ActiceCell.js